import React from 'react';


const ToolSection = (props) => {
  return (
    <section className="faqs_section section_space pt-0">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 text-center tool_section">
                    <h2>{props.title1}</h2>
                    <h3>{props.title2}</h3>

                    <button className="read_more btn btn-secondary">Contact Now</button>
                    
                </div>

                

            </div>
        </div>
    </section>
  );
};

export default ToolSection;